module.exports = ".header-less-tabs .mat-tab-group .mat-tab-header {\n  display: none; }\n\n.hunter-health-container {\n  margin-top: -48px; }\n\n.layout-normalizer {\n  height: 12vh; }\n\n/*prevent scrolling within tabs*/\n\n.mat-tab-body-content {\n  overflow: hidden !important;\n  padding-top: 2px;\n  padding-bottom: 2px; }\n\n.back-button {\n  float: left;\n  height: 100%; }\n\n@media only screen and (max-width: 678px) {\n  .back-button {\n    display: none; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hunt/pages/hunt-page/hunt-page.component.scss
// module id = ./src/app/hunt/pages/hunt-page/hunt-page.component.scss
// module chunks = main